"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrUspBoxes = void 0;
const react_1 = __importDefault(require("react"));
const fdr_usp_box_1 = require("./fdr-usp-box");
const fdr_usp_boxes_styles_1 = require("./fdr-usp-boxes.styles");
const FdrUspBoxes = ({ title, boxes, testId = 'fdr-usp-boxes', }) => {
    return (react_1.default.createElement(fdr_usp_boxes_styles_1.UspBoxesWrapper, { "data-id": testId },
        title ? (react_1.default.createElement(fdr_usp_boxes_styles_1.UspBoxesTitle, { "data-id": "main-heading" }, title)) : null, boxes === null || boxes === void 0 ? void 0 :
        boxes.map(function renderUspBox(box, index) {
            return react_1.default.createElement(fdr_usp_box_1.FdrUspBox, Object.assign({ key: index }, box));
        })));
};
exports.FdrUspBoxes = FdrUspBoxes;
//# sourceMappingURL=fdr-usp-boxes.js.map